/* smooth-experience.js — page-curtain transition, scroll reveals, parallax, price reveal. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  var curtain = document.querySelector('[data-page-curtain]');
  if (curtain && !reduce) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || a.target === '_blank' || a.hasAttribute('download')) return;
      var url; try { url = new URL(a.href); } catch (er) { return; }
      if (url.origin !== location.origin) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      curtain.classList.add('is-active');
      setTimeout(function () { window.location.href = a.href; }, 360);
    });
    window.addEventListener('pageshow', function () { curtain.classList.remove('is-active'); });
  }

  // Grid/card/collection reveals are owned by gsap-animations.js (desktop) to
  // avoid double-animating the same elements. This handles explicit opt-ins only.
  var revealSel = '.reveal-init';
  var items = Array.prototype.slice.call(document.querySelectorAll(revealSel));
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en, i) {
        if (en.isIntersecting) {
          var el = en.target;
          setTimeout(function () { el.classList.add('is-revealed'); }, (i % 6) * 70);
          io.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { el.classList.add('reveal-init'); io.observe(el); });
  } else { items.forEach(function (el) { el.classList.add('is-revealed'); }); }

  var prices = document.querySelectorAll('.price-item--regular, .price__regular .price-item, .price-item--sale');
  if ('IntersectionObserver' in window && !reduce) {
    var pio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('price-reveal', 'is-in'); pio.unobserve(en.target); }
      });
    }, { threshold: 0.6 });
    prices.forEach(function (el) { el.classList.add('price-reveal'); pio.observe(el); });
  }

  if (!isMobile && !reduce && window.gsap && window.ScrollTrigger) {
    window.gsap.registerPlugin(window.ScrollTrigger);
    document.querySelectorAll('.media > img, .banner__media img').forEach(function (img) {
      window.gsap.to(img, { yPercent: 8, ease: 'none', scrollTrigger: { trigger: img, scrub: true } });
    });
  }
})();
